import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M19.5 19.5h3v3h-3v-3zm-6 0h3v3h-3v-3zm6-6h3v3h-3v-3zm-6 0h3v3h-3v-3zm-10 2h5v5h-5v-5zm-2-2h9v9h-9v-9zm14-10h5v5h-5v-5zm-2-2h9v9h-9v-9zm-10 2h5v5h-5v-5zm-2-2h9v9h-9v-9z" stroke="currentColor" fill="none" /></svg>;